import React from 'react';

const CardItem = ({ children }) => {
    return <div className='item'>{children}</div>;
};
export default CardItem;
